import ReactPannellum from 'react-pannellum';
import uniqueId from 'lodash/uniqueId';
import React, { useContext } from 'react';
import { Optional } from '@honda-canada/design-system-react';
import Context from './service/Context';
import useInterior360State from './hooks/useInterior360State';
import useThreeSixtyState from './hooks/useThreeSixtyState';
import ThreeSixtyContainer, { ThreeSixtyAnimatedLoader } from './ThreeSixtyContainer';
import { Image, PannellumContainer } from './ExteriorView.styles';
const Interior360View = ({ assetColor, images, assetType, gtmVehicleData }) => {
    const { is360Mode } = useContext(Context);
    const { deviceImages, iconSize, imageLoaded, isImagesLoading, imgRef, getPanoramicImages, onImageLoaded, imgHeight } = useThreeSixtyState({
        accessoriesWithOverlayImages: undefined,
        images,
        assetColor,
        is360Mode,
    });
    const { url, alt, currentImageUrl, panoramicImageLoaded, setPanoramicImageLoaded, defaultConfig, hideRotatingIcon } = useInterior360State({
        getPanoramicImages,
        assetColor,
        deviceImages,
        assetType,
    });
    return (React.createElement(ThreeSixtyContainer, { gtmVehicleData: gtmVehicleData, height: imgHeight, hideRotatingIcon: hideRotatingIcon, iconSize: iconSize, is360EnableVisible: !is360Mode && imageLoaded, isImageLoading: !(is360Mode || imageLoaded) || isImagesLoading },
        React.createElement(Optional, { when: !is360Mode },
            React.createElement(Image, { ref: imgRef, is360Mode: is360Mode, onLoad: onImageLoaded, alt: alt, src: currentImageUrl })),
        React.createElement(Optional, { when: is360Mode },
            React.createElement(PannellumContainer, null,
                React.createElement(Optional, { when: !panoramicImageLoaded },
                    React.createElement(ThreeSixtyAnimatedLoader, { isVisible: true })),
                React.createElement(ReactPannellum, { onPanoramaLoaded: () => {
                        setPanoramicImageLoaded(true);
                    }, config: { ...defaultConfig, preview: currentImageUrl }, style: { width: '100%', height: '100%' }, sceneId: assetColor, id: uniqueId('interior-360'), preview: currentImageUrl, imageSource: url })))));
};
export default Interior360View;
